import React, { useCallback, useMemo, useState } from 'react';
import Select from 'components/Form/Select';
import { withTranslation } from 'i18n';
import PropTypes from 'prop-types';

function JobPositionSelect({
  jobPositions,
  className,
  selectedJobPosition,
  onAddApplication,
  t,
  popupContainerRef,
  disabled,
  ...rest
}) {
  const [isLoading, setIsLoading] = useState(false);

  const memoizedChoices = useMemo(
    () =>
      jobPositions.map(({ node: { pk, position, isActive } }) => ({
        value: pk,
        label:
          isActive === false
            ? `${position} (${t('archived_jobPosition')})`
            : position,
      })),
    [jobPositions, t],
  );

  const handleChange = useCallback(
    async (val) => {
      setIsLoading(true);
      await onAddApplication(val);
      setIsLoading(false);
    },
    [onAddApplication],
  );

  return (
    <Select
      data-testid={rest['data-testid'] || ''}
      value={selectedJobPosition}
      choices={memoizedChoices}
      placeholder={t('chooseJobPosition')}
      className={className}
      popupContainer={popupContainerRef}
      onChange={handleChange}
      disabled={disabled || isLoading}
      withSearch
      optionFilterProp="children"
      notFoundContent={t('noResults')}
    />
  );
}

JobPositionSelect.propTypes = {
  jobPositions: PropTypes.array,
  className: PropTypes.string,
  selectedJobPosition: PropTypes.string,
  onAddApplication: PropTypes.func,
  t: PropTypes.func.isRequired,
  popupContainerRef: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default withTranslation('translation')(JobPositionSelect);
